import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../data-service';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class ShareDataService {
  branch: any;
  currentBranch: BehaviorSubject<any> = new BehaviorSubject('');

  public getBranch() :Observable<any> {
    return this.currentBranch.asObservable();
  }

  changeBranch(selectedBranch?: any) {
    this.branch = selectedBranch;
    this.currentBranch.next(selectedBranch);
  }

  getCurrentBranch() {
    return this.branch;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data-services/share/share.service.ts